"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("../Customer/DocumentType"), exports);
const classTransformer_1 = require("../classTransformer");
const DocumentType_1 = __importDefault(require("../Customer/DocumentType"));
const class_validator_1 = require("class-validator");
const Office_1 = __importDefault(require("./Office"));
const Document_1 = __importDefault(require("./Document"));
const Deed_1 = __importDefault(require("./Deed"));
const DeedType_1 = __importDefault(require("./DeedType"));
class DocumentType extends DocumentType_1.default {
    constructor() {
        super(...arguments);
        this.public_description = null;
        this.private_description = null;
        this.archived_at = null;
    }
}
exports.default = DocumentType;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({
        groups: [
            "createDocument",
            "createDeedType",
            "updateFolder",
            "updateDeed",
            "updateDeedType",
        ],
        message: "UID is required",
    }),
    __metadata("design:type", String)
], DocumentType.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateDocumentType"] }),
    (0, class_validator_1.NotEquals)("", {
        groups: ["updateDocumentType"],
        message: "Nom du document ne peut pas être vide",
    }),
    (0, class_validator_1.IsNotEmpty)({
        groups: ["createDocumentType"],
        message: "Nom du document ne peut pas être vide",
    }),
    __metadata("design:type", String)
], DocumentType.prototype, "name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateDocumentType"] }),
    (0, class_validator_1.IsOptional)({ groups: ["createDocumentType"] }),
    __metadata("design:type", Object)
], DocumentType.prototype, "public_description", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateDocumentType"] }),
    (0, class_validator_1.IsOptional)({ groups: ["createDocumentType"] }),
    __metadata("design:type", Object)
], DocumentType.prototype, "private_description", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateDocumentType"] }),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], DocumentType.prototype, "archived_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateDocumentType"] }),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createDocumentType"], message: "Office is required" }),
    (0, class_validator_1.ValidateNested)({ groups: ["createDocumentType"] }),
    (0, classTransformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], DocumentType.prototype, "office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Document_1.default),
    __metadata("design:type", Array)
], DocumentType.prototype, "documents", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Deed_1.default),
    __metadata("design:type", Array)
], DocumentType.prototype, "deeds", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DeedType_1.default),
    __metadata("design:type", Array)
], DocumentType.prototype, "deed_type", void 0);
